import { root } from '../../../../../../../store/constants';

export const getShowSignInInterface = (): boolean => {
    let isShowInterface = true;
    if (root.App.utmLanding && root.App.utmLanding.text) {
        isShowInterface = false;
    }
    return isShowInterface;
}
